<a (click)="goToAiAgents()" class="alc-icon-and-name back-to-link">
  <mat-icon>chevron_left</mat-icon>
  <span translate="parameters/alcmeon-ai/edit-agent/back"></span>
</a>

<mat-card>
  <mat-card-title>{{ title }}</mat-card-title>

  <form [formGroup]="form" (ngSubmit)="save()">
    <!-- Agent name -->
    <mat-form-field appearance="outline" class="shrink">
      <mat-label translate="parameters/alcmeon-ai/edit-agent/name"></mat-label>
      <input type="text" matInput formControlName="name" />
      <mat-error *ngIf="form.controls.name.errors?.required" translate="common/form_errors/required"></mat-error>
    </mat-form-field>

    <!-- Active -->
    <div>
      <mat-slide-toggle color="primary" formControlName="isActive">
        <span translate="parameters/alcmeon-ai/edit-agent/active"></span>
      </mat-slide-toggle>
    </div>

    <!-- mode AI.ssistant or AI Bot Connector -->
    <mat-radio-group formControlName="mode">
      <mat-radio-button [value]="aiAgentModeEnum.aissitant">
        <span translate="parameters/alcmeon-ai/edit-agent/use-aissistant"></span>
      </mat-radio-button>
      <mat-radio-button [value]="aiAgentModeEnum.aiBot">
        <span translate="parameters/alcmeon-ai/edit-agent/use-ai-bot-connector"></span>
      </mat-radio-button>
    </mat-radio-group>

    <!-- Agent Type -->
    <app-select
      *ngIf="typeItems"
      appearance="outline"
      class="type-select"
      [control]="form.get('type')"
      [items]="typeItems"
      [labelKey]="'parameters/alcmeon-ai/edit-agent/agent-type'"
      [formFieldClass]="'no-vertical-padding'">
    </app-select>
    <mat-hint
      *ngIf="!isGaiaExists"
      class="specific-hint"
      translate="parameters/alcmeon-ai/edit-agent/no-gaia"></mat-hint>
    <mat-error
      *ngIf="form.controls.type.errors?.required && form.controls.type.dirty"
      class="specific-error"
      translate="common/form_errors/required"></mat-error>

    <!-- Type 0 -> GAIA , Type 1 -> Third party -->
    <div *ngIf="form.get('type').value === 0" class="gaia" formGroupName="gaiaData">
      <!-- Knowledge documents used -->
      <app-select
        *ngIf="knowledgeDocsItems"
        appearance="outline"
        class="docs-select"
        [control]="form.get('gaiaData.datasourceIds')"
        [items]="knowledgeDocsItems"
        [multiple]="true"
        labelKey="parameters/alcmeon-ai/edit-agent/knowledge-docs"
        [formFieldClass]="'no-vertical-padding'">
      </app-select>
      <mat-hint
        class="specific-hint"
        align="start"
        [innerHTML]="'parameters/alcmeon-ai/edit-agent/knowledge-docs/hint' | translate"></mat-hint>

      <div>
        <mat-slide-toggle color="primary" formControlName="withSource" class="toggle-source">
          <span translate="parameters/alcmeon-ai/edit-agent/display-knowledge-docs"></span>
        </mat-slide-toggle>
      </div>

      <!-- Company context-->
      <mat-form-field appearance="outline" class="shrink">
        <mat-label translate="parameters/alcmeon-ai/edit-agent/company-context"></mat-label>
        <textarea
          matInput
          formControlName="companyContext"
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="3"></textarea>
        <mat-hint translate="parameters/alcmeon-ai/edit-agent/company-context/hint"></mat-hint>
        <mat-error
          *ngIf="form.get('gaiaData.companyContext').errors?.required"
          translate="common/form_errors/required"></mat-error>
      </mat-form-field>
      <!-- Assistant context-->
      <mat-form-field appearance="outline" class="shrink">
        <mat-label translate="parameters/alcmeon-ai/edit-agent/assistant-context"></mat-label>
        <textarea
          matInput
          formControlName="assistantContext"
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="3"></textarea>
        <mat-hint translate="parameters/alcmeon-ai/edit-agent/assistant-context/hint"></mat-hint>
        <mat-error
          *ngIf="form.get('gaiaData.assistantContext').errors?.required"
          translate="common/form_errors/required"></mat-error>
      </mat-form-field>
      <!-- Style of the answer-->
      <mat-form-field appearance="outline" class="shrink style-answer-input">
        <mat-label translate="parameters/alcmeon-ai/edit-agent/style-of-answer"></mat-label>
        <textarea
          matInput
          formControlName="answerStyle"
          cdkTextareaAutosize
          cdkAutosizeMinRows="2"
          cdkAutosizeMaxRows="3"></textarea>
        <mat-hint translate="parameters/alcmeon-ai/edit-agent/style-of-answer/hint"></mat-hint>
        <mat-error
          *ngIf="form.get('gaiaData.answerStyle').errors?.required"
          translate="common/form_errors/required"></mat-error>
      </mat-form-field>
      <!-- Disallow toxic questions -->
      <div>
        <mat-slide-toggle color="primary" formControlName="checkToxic">
          <span translate="parameters/alcmeon-ai/edit-agent/toxic-questions"></span>
        </mat-slide-toggle>
      </div>
      <!-- Anonymize private data -->
      <div>
        <mat-slide-toggle
          color="primary"
          formControlName="anonymize"
          [class.toggle-anonymize]="form.get('gaiaData.anonymize').value">
          <span translate="parameters/alcmeon-ai/edit-agent/anonymize-private-data"></span>
        </mat-slide-toggle>
      </div>
      <!-- Don't anonymize -->
      <mat-form-field
        *ngIf="form.get('gaiaData.anonymize').value"
        appearance="outline"
        class="shrink textarea-anonymize">
        <mat-label translate="parameters/alcmeon-ai/edit-agent/no-anonymize"></mat-label>
        <textarea
          cdkTextareaAutosize
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="10"
          matInput
          formControlName="allowListString"></textarea>
        <mat-hint translate="parameters/alcmeon-ai/edit-agent/no-anonymize/hint"></mat-hint>
        <mat-error
          *ngIf="form.get('gaiaData.allowListString').errors?.required"
          translate="common/form_errors/required"></mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="form.get('type').value === 1" class="third-party">
      <!-- Third party AI Endpoint URL -->
      <mat-form-field appearance="outline" class="shrink">
        <mat-label translate="parameters/alcmeon-ai/edit-agent/third-party-endpoint-url"></mat-label>
        <input type="text" matInput formControlName="externalUrl" />
        <mat-error
          *ngIf="form.controls.externalUrl.errors?.required"
          translate="common/form_errors/required"></mat-error>
        <mat-error *ngIf="form.controls.externalUrl.errors?.url" translate="common/form_errors/invalid_url"></mat-error>
        <mat-error
          *ngIf="form.controls.externalUrl.errors?.pattern"
          translate="parameters/alcmeon-ai/edit-agent/error/invalid-url"></mat-error>
      </mat-form-field>

      <!-- Third party AI API key -->
      <mat-form-field appearance="outline" class="shrink">
        <mat-label translate="parameters/alcmeon-ai/edit-agent/third-party-api-key"></mat-label>
        <input type="text" matInput formControlName="apiKey" />
        <mat-hint translate="parameters/alcmeon-ai/edit-agent/agent-type/third-party-hint"></mat-hint>
        <mat-error *ngIf="form.controls.apiKey.errors?.required" translate="common/form_errors/required"></mat-error>
      </mat-form-field>

      <!-- Third party public key -->
      <ng-container *ngIf="!isCreation">
        <mat-form-field appearance="outline" class="shrink public-key">
          <mat-label translate="parameters/alcmeon-ai/edit-agent/public-key"></mat-label>
          <textarea cdkTextareaAutosize matInput formControlName="publicKey"></textarea>
        </mat-form-field>
        <div class="public-key-link">
          <a
            href="https://developers.alcmeon.com/reference/post_suggest-answer"
            target="_blank"
            class="alc-icon-and-name">
            <span translate="parameters/alcmeon-ai/edit-agent/public-key-link"></span>
            <mat-icon>launch</mat-icon>
          </a>
        </div>
        <div class="public-key-copy">
          <button mat-raised-button type="button" (click)="copyPublicKey()" translate="copy"></button>
        </div>
      </ng-container>

      <div class="documentation-link">
        <a href="https://developers.alcmeon.com/docs/ai-connector" target="_blank" class="alc-icon-and-name">
          <span translate="parameters/alcmeon-ai/edit-agent/open-technical-doc"></span>
          <mat-icon>launch</mat-icon>
        </a>
      </div>
    </div>

    <div class="buttons">
      <button mat-raised-button type="submit" color="primary" [disabled]="form.invalid || form.pristine">
        <span translate="save"></span>
      </button>
      <button mat-raised-button type="button" (click)="goToAiAgents()"><span translate="cancel"></span></button>
    </div>
  </form>

  <app-card-footer *ngIf="!isCreation" [data]="footerContent"></app-card-footer>
</mat-card>
